import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { percsTriptych } from 'assets/content/membership/prospectPercs';
import desktopBackground from 'assets/images/membership/prose-assortment-of-custom-haircare-and-skincare-products-desktop.jpg';
import mobileBackground from 'assets/images/membership/prose-assortment-of-custom-haircare-and-skincare-products-mobile.jpg';
import tabletBackground from 'assets/images/membership/prose-assortment-of-custom-haircare-and-skincare-products-tablet.jpg';

import { PercsTriptych } from '../SharedComponents/PercsTriptych';

const ProspectIntro = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  width: '100%',
  padding: '72px 24px',
  backgroundColor: theme.colors.neutral[500],
  backgroundImage: `url(${mobileBackground.src})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  height: '120vh',
  minHeight: 890,
  [legacyTheme.breakpoints.up('sm')]: {
    backgroundImage: `url(${tabletBackground.src})`,
  },
  [legacyTheme.breakpoints.up('lg')]: {
    backgroundImage: `url(${desktopBackground.src})`,
  },
});

const Intro = styled('p')({
  fontFamily: legacyTheme.typography.saol,
  fontSize: '25px',
  lineHeight: 1.64,
  color: theme.colors.primary[400],
  maxWidth: 1024,

  [legacyTheme.breakpoints.up('md')]: {
    fontSize: '28px',
  },
});

const B = styled('span')({
  fontFamily: legacyTheme.typography.simplonMono,
  fontSize: '25px',
  lineHeight: 1.64,
  color: theme.colors.accent[300],
  textTransform: 'uppercase',
  fontWeight: 'bold',
  maxWidth: 1024,

  [legacyTheme.breakpoints.up('md')]: {
    fontSize: '28px',
  },
});

const ProspectPercs = () => {
  return (
    <>
      <ProspectIntro>
        <Intro align="center" color="noir">
          Our <B>Subscription service</B> delivers Prose on your schedule, so you can enjoy custom
          care and continually-improving results.
        </Intro>
      </ProspectIntro>

      <PercsTriptych content={percsTriptych} />
    </>
  );
};

ProspectPercs.propTypes = {};

ProspectPercs.defaultProps = {};

export default ProspectPercs;
